</<template>
    <common-login @user-info="login"></common-login>
</template>

<script>
import CommonLogin from '@/components/CommonLogin.vue'
import { transferUploadLogin } from '@/api'
import { toErrorMessage } from '@/common'

export default {
  title: '',
  components: {
    CommonLogin
  },
  methods: {
    login: function (event) {
      this.$store.commit('progress/setLoading', true)
      transferUploadLogin(event.exchangeId, event.email, event.password).then(result => {
        localStorage.setItem('role', 'receiver')
        localStorage.setItem('exchange_id', result.exchange_id)
        localStorage.setItem('loginType', 'upload')
        this.$router.push({ name: 'receiverUpload' })
        this.$store.commit('progress/setLoading', false)
      })
        .catch(e => {
          // エラー内容でメッセージを切り替える
          const errorMessage = toErrorMessage(e.response.status)
          event.errorMessageList.push(errorMessage)
          this.$store.commit('progress/setLoading', false)
        })
    }
  }
}
</script>
<style>
</style>
